import React from 'react';
import FileBase64 from 'react-file-base64';
import 'whatwg-fetch';

import { EditorState } from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import createMentionPlugin, { defaultSuggestionsFilter } from 'draft-js-mention-plugin';
import 'draft-js-mention-plugin/lib/plugin.css';
import file_upload_rules from 'src/data/file-upload-rules';

import userImage from 'src/images/user.png';
import withAuth from 'src/hoc/withAuth';

const apiEmployeeShow = '/api/employee/';
const linkToUser = '/dashboard/user/';
const attachment_limit = 5;

class MyWallPost extends React.Component {
  constructor(props) {
    super(props);

    this.mentionPlugin = createMentionPlugin();

    this.state = {
      title: '',
      editorState: EditorState.createEmpty(),
      dataEmployee: [],
      suggestions: [], // used as the base for search filter
      taggedUsers: [],
      files: [],
    };

    // Editor handling
    this.onChange = (editorState) => {
      this.setState({ editorState });
    };
    this.onSearchChange = ({ value }) => {
      this.setState({
        dataEmployee: defaultSuggestionsFilter(value, this.state.suggestions),
      });
    };
    this.onAddMention = (mention) => {
      let userTagged = {
        id: mention.get('id'),
        username: mention.get('name'),
        editorLength: this.state.editorState.getCurrentContent().getPlainText().length, // used to later remove this tagged User
      };

      let listTagged = this.state.taggedUsers;
      listTagged.push(userTagged);
      this.setState({
        taggedUsers: listTagged,
      });
    };
    this.focus = () => {
      this.editor.focus();
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  clearUsersTaggedAtIndex(index) {
    let newUserTagged = this.state.taggedUsers;
    let i = newUserTagged.length - 1;
    while (i-- >= 0) {
      if (newUserTagged[i + 1].editorLength > index) {
        newUserTagged.splice(i + 1, 1);
        this.setState({
          taggedUsers: newUserTagged,
        });
        i = -1; // end loop
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.editorState !== this.state.editorState) {
      if (
        prevState.editorState.getCurrentContent().getPlainText().length >
        this.state.editorState.getCurrentContent().getPlainText().length
      ) {
        // check for removal
        this.clearUsersTaggedAtIndex(this.state.editorState.getCurrentContent().getPlainText().length);
      }
    }
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }
  // For base64 Input
  getFiles(files) {
    // multiple input
    let filesAdded = false;
    let oldFiles = this.state.files;
    let fileNumber = oldFiles.length;

    for (let i = 0; i < files.length; i++) {
      // we need to check in a loop, because of multiple input
      if (fileNumber >= attachment_limit) {
        this.props.openToast(false, 'Vous avez atteint la limite de pièces-jointes');
        break;
      } else if (files[0].file.size > file_upload_rules.sizeLimit) {
        // file too big
        this.props.openToast(false, 'La taille maximale autorisée est de 3Mo');
        break;
      } else if (file_upload_rules.acceptedTypes.indexOf(files[0].file.type) === -1) {
        // file type not accepted
        this.props.openToast(false, 'Les fichiers autorisés sont .jpg, .png et .pdf');
        break;
      } else {
        oldFiles.push(files[i]);
        fileNumber++;
        filesAdded = true;
      }
    }

    if (filesAdded) {
      this.setState({ files: oldFiles });
    }
  }
  removeFile(index) {
    let newAttachments = this.state.files;
    newAttachments.splice(index, 1);
    this.setState({ files: newAttachments });
  }

  componentDidMount() {
    let queryURL = apiEmployeeShow;
    let graphQL = '{ employees{ id, firstname, lastname, profileImage, user{ id, username } } }';
    queryURL += graphQL;
    this.props
      .authFetch(queryURL, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        method: 'GET',
      })
      .then((resp) => resp.json())
      .then(
        function (data) {
          if (data['data']['employees']) {
            this.setState({
              dataEmployee: this.transformToMention(data['data']['employees']),
              suggestions: this.transformToMention(data['data']['employees']),
            });
          }
          //console.log(data);
        }.bind(this)
      )
      .catch(
        function (error) {
          console.log('erreur fetch employee list: \n' + error);
        }.bind(this)
      );
  }

  transformToMention(data) {
    let res = [];
    for (let i = 0; i < data.length; i++) {
      let user = {
        id: data[i].id,
        name: data[i].user.username,
        link: linkToUser + data[i].user.id,
        avatar: data[i].profileImage ? '/' + data[i].profileImage : userImage,
      };
      res.push(user);
    }
    return res;
  }

  render() {
    const { MentionSuggestions } = this.mentionPlugin;
    const plugins = [this.mentionPlugin];

    const { files } = this.state;

    return (
      <div className='chatBox alignHorizontal'>
        <div className='chatBox-header'>
          <button onClick={this.props.toggleMenuPost} type='button' className='btn btn-sm btn-outline-success'>
            <span className='icon icon-cross' />
          </button>
          <h5>Poster un commentaire</h5>
        </div>

        <div className='chatBox-content'>
          <input
            name='title'
            value={this.state.title}
            onChange={this.handleInputChange}
            type='text'
            style={{ marginBottom: 5 }}
            className='form-control'
            placeholder='Donner un titre au commentaire'
          />
          <div onClick={this.focus} className='editor editor-mention form-control comment-zone'>
            <Editor
              editorState={this.state.editorState}
              onChange={this.onChange}
              plugins={plugins}
              ref={(element) => {
                this.editor = element;
              }}
            />
            <MentionSuggestions
              onSearchChange={this.onSearchChange}
              suggestions={this.state.dataEmployee}
              onAddMention={this.onAddMention}
            />
          </div>
          <div className='chatBox-attachment-list'>
            {files.map((data, i) => (
              <div className='tag-pill'>
                <span onClick={() => this.removeFile(i)} className='tag-pill-cross icon icon-cross'></span>
                <span title={data.name} className='tag-pill-text'>
                  {data.name}
                </span>
              </div>
            ))}
          </div>
        </div>

        <div className='chatBox-cmd'>
          <FileBase64 className='btn btn-sm btn-outline-success' multiple={true} onDone={this.getFiles.bind(this)} />
          <button onClick={this.handleSubmit} type='button' className='btn btn-sm btn-success'>
            Poster
          </button>
        </div>
      </div>
    );
  }

  handleSubmit() {
    if (this.props.onPost) {
      let comment = this.state.editorState.getCurrentContent().getPlainText();

      console.log(comment);

      if ((comment && comment.trim() != '') || this.state.files.length > 0) {
        let json = {
          post: {
            title: this.state.title.trim() != '' ? this.state.title : 'Commentaire',
            text: comment ? comment : '',
            taggedEmployees: this.state.taggedUsers, // id's must be the employees id
          },
          files: this.state.files,
        };

        this.props.onPost(json);
        this.reset();
      } else {
        this.props.openToast(false, 'Le post est vide');
      }
    }
  }

  reset() {
    this.setState({
      title: '',
      editorState: EditorState.createEmpty(),
      taggedUsers: [],
      files: [],
    });
  }
}

export default withAuth(MyWallPost);
